import { StatTableTd } from "components/StatsTable/styles";
import styled from "styled-components";

export const OrgName = styled.span`
  @media (max-width: 1000px) {
    font-size: 11.5pt;
  }

  @media (max-width: 700px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 10.5pt;
  }
`;

export const OrgLogoNameCell = styled(StatTableTd)`
  text-align: left;

  span {
    min-width: 1px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: clip;
  }

  min-width: ${({ frozenWidth }) => `${frozenWidth ?? 200}px;`};
  max-width: ${({ frozenWidth }) => `${frozenWidth ?? 200}px;`};

  @media (max-width: 1000px) {
    min-width: ${({ frozenWidth }) => `${frozenWidth ?? 175}px;`};
    max-width: ${({ frozenWidth }) => `${frozenWidth ?? 175}px;`};
  }

  @media (max-width: 700px) {
    min-width: 175px;
    max-width: 175px;
  }
`;

export const OrgLogoContainer = styled.div<{ smallerSize?: boolean }>`
  height: 30px;
  min-width: 33px;
  max-width: 33px;
  margin: 4px 8px;
  ${({ smallerSize }) =>
    smallerSize &&
    `
  height: 26px;
  min-width: 29px;
  max-width: 29px;
  margin: 4px 8px 4px 5px;`}

  @media (max-width: 1000px) {
    min-width: 31px;
    max-width: 31px;
    height: 29px;
    margin: 4px 8px;
    ${({ smallerSize }) =>
      smallerSize &&
      `
      height: 26px;
      min-width: 31px;
      max-width: 31px;
      margin: 3px 8px 3px 5px;`}
  }

  @media (max-width: 700px) {
    min-width: 29px;
    max-width: 29px;
    height: 27px;
    margin: 2px 5px;
    ${({ smallerSize }) =>
      smallerSize &&
      `
    height: 24px;
    min-width: 29px;
    max-width: 29px;
    margin: 2px 5px 2px 3px;`}
  }
`;
